import { useTranslations } from 'next-intl'
import React from 'react'
import dynamic from 'next/dynamic'
import { Checkbox, Text, TextProps, useColorModeValue } from '@chakra-ui/react'

const PdfModal = dynamic(() => import('./PdfModal'), {
  ssr: false,
})

interface IProps {
  allAgreementsEntries: any[]
  setCompassAgreements: React.Dispatch<React.SetStateAction<any>>
  textStyle?: TextProps
}

export const Agreements = ({
  allAgreementsEntries,
  setCompassAgreements,
  textStyle,
}: IProps) => {
  const t = useTranslations()
  const grayColor = useColorModeValue('gray.600', 'gray.200')

  const handleAgree = (key: string) => {
    setCompassAgreements((prevState: any) => ({
      ...prevState,
      [key]: {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ...prevState[key],
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        isChecked: !prevState[key].isChecked,
      },
    }))
  }

  const getAgreementTitle = (value: string) => {
    if (value === 'REFUND') {
      return t('checkout.agree-with-refund')
    }

    if (value === 'PENDING_RELOCATION') {
      return t('checkout.agree-with-pending-relocation')
    }

    if (value === 'INDIANA_SALES_TAX_TERMS') {
      return t('checkout.agree-to')
    }

    return t('checkout.agree-with')
  }

  return (
    <>
      {allAgreementsEntries.map(([key, value]) => {
        return (
          <React.Fragment key={`agreementEntry-${key}`}>
            {value.isShown && (
              <PdfModal
                title={value?.text}
                filePath={value?.pdfFile}
                handleAgree={() => handleAgree(key)}
                isChecked={value.isChecked}
                trigger={
                  <Checkbox
                    colorScheme="brand.600"
                    size="lg"
                    borderColor={grayColor}
                    iconColor="blue.400"
                    iconSize="1rem"
                    isChecked={value.isChecked}
                    onChange={() => {
                      if (value.isChecked) {
                        handleAgree(key)
                      }
                    }}
                    data-test-id={value.title}
                  >
                    <Text
                      fontSize={11.5}
                      color={grayColor}
                      ml={2}
                      {...textStyle}
                    >
                      {getAgreementTitle(value.title)}
                      <Text
                        as={'span'}
                        ml={1}
                        textDecoration={'underline'}
                        color={grayColor}
                      >
                        {value.text}
                      </Text>
                    </Text>
                  </Checkbox>
                }
              />
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}
